import React from 'react';
import MarkdownConverter from '../MarkdownConverter.jsx';

export default class FactBox extends React.PureComponent {
  static propTypes = {
    widget: React.PropTypes.shape({
      header: React.PropTypes.string.isRequired,
      body: React.PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    const { widget } = this.props;

    return (
      <div className="fact-box">
        <h2 className="heading">{widget.header}</h2>
        <MarkdownConverter markdown={widget.body} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/FactBox.jsx